import { useAppSelector } from 'hooks/reduxHooks'
import { getCurrentUserId } from 'selectors/accountSelectors'
import { getCanViewLuxPlusBenefits, getIsFreePreviewLuxPlusMember } from 'luxPlus/selectors/featureToggle'

/** Search visibility depends on the signed-in customer and their current membership. */
export default function useOfferDetailViewerKey() {
  const userId = useAppSelector(getCurrentUserId)
  const canViewBenefits = useAppSelector(getCanViewLuxPlusBenefits)
  const isFreePreview = useAppSelector(getIsFreePreviewLuxPlusMember)
  return JSON.stringify([userId, canViewBenefits, isFreePreview])
}
